import { OrganizationPayload } from '_api/types';
import { US_STATES } from '_constants';
import { InputField, SelectField } from 'components/molecules/formFields';
import React from 'react';

import { FormBuilder } from './form-builder';
import { BaseFormProps } from './types';

export const OrganizationForm = ({
  disableAll = false,
  hideSubmitButtons = false,
  initValue,
  onBack,
  onSubmit,
}: BaseFormProps<OrganizationPayload>) => {
  const formFields = [
    {
      component: InputField,
      fieldKey: 'name',
      label: 'Name',
      required: true,
      xs: 4,
    },
    {
      component: InputField,
      fieldKey: 'phoneNumber',
      label: 'Phone Number',
      required: true,
      type: 'number',
      mask: '(000) 000-0000',
      xs: 4,
    },
    {
      component: InputField,
      fieldKey: 'streetAddress',
      label: 'Street Address',
      required: true,
      xs: 4,
    },
    {
      component: InputField,
      fieldKey: 'city',
      label: 'City',
      required: true,
      xs: 4,
    },
    {
      component: SelectField,
      fieldKey: 'state',
      label: 'State',
      options: US_STATES.map((state) => ({
        description: state,
        name: state,
      })),
      required: true,
      xs: 2,
    },
    {
      component: InputField,
      fieldKey: 'zipCode',
      label: 'Zip Code',
      required: true,
      xs: 2,
    },
  ];

  return (
    <FormBuilder
      disabled={disableAll}
      initValues={initValue}
      formFields={formFields}
      onBack={onBack}
      onSubmit={onSubmit}
      hideSubmit={hideSubmitButtons}
    />
  );
};
